"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
class Player {
    constructor(data) {
        this.type = 'character';
        this.id = data.id;
        this.playerName = data.playerName;
        this.characterName = data.characterName;
        this.currentCharacter = data.currentCharacter || data.characterName;
        this.userId = data.userId;
        this.inventory = [...(data.inventory || [])];
        this.stats = [...(data.stats || [])];
        this.sceneHistory = [...(data.sceneHistory || [])];
        this.currentScene = data.currentScene;
        this.completed = data.completed ?? false;
        this.hasActiveAdventures = data.hasActiveAdventures ?? false;
        this.activeAdventureDetails = data.activeAdventureDetails;
        this.timeZoneOffsetMinutes = data.timeZoneOffsetMinutes;
        this.openingSessionTopValid = data.openingSessionTopValid ?? false;
        this.hostScriptBag = data.hostScriptBag;
    }
    hasItem(itemName) {
        return this.inventory.includes(itemName);
    }
    hasStat(statName) {
        return this.stats.includes(statName);
    }
    hasVisited(sceneId) {
        return this.sceneHistory.includes(sceneId);
    }
    addItem(itemName) {
        if (!this.hasItem(itemName)) {
            this.inventory.push(itemName);
        }
    }
    removeItem(itemName) {
        const index = this.inventory.indexOf(itemName);
        if (index > -1) {
            this.inventory.splice(index, 1);
        }
    }
    addStat(statName) {
        if (!this.hasStat(statName)) {
            this.stats.push(statName);
        }
    }
    removeStat(statName) {
        const index = this.stats.indexOf(statName);
        if (index > -1) {
            this.stats.splice(index, 1);
        }
    }
    moveToScene(sceneId) {
        if (!this.hasVisited(sceneId)) {
            this.sceneHistory.push(sceneId);
        }
        this.currentScene = sceneId;
    }
    setCompleted(completed) {
        this.completed = completed;
    }
    isCompleted() {
        return this.completed;
    }
    setHasActiveAdventures(value) {
        this.hasActiveAdventures = value;
    }
    setOpeningSessionTopValid(value) {
        this.openingSessionTopValid = value;
    }
    setHostScriptBag(value) {
        this.hostScriptBag = value;
    }
    mergeHostScriptBag(patch) {
        this.hostScriptBag = {
            joinOptions: { ...this.hostScriptBag?.joinOptions, ...patch.joinOptions },
            pickerLists: { ...this.hostScriptBag?.pickerLists, ...patch.pickerLists },
            entityStatuses: { ...this.hostScriptBag?.entityStatuses, ...patch.entityStatuses },
            flags: { ...this.hostScriptBag?.flags, ...patch.flags }
        };
    }
    hasActiveAdventuresFlag() {
        return this.hasActiveAdventures;
    }
    setCurrentCharacter(characterName) {
        this.characterName = characterName;
        this.currentCharacter = characterName;
    }
    getCurrentCharacter() {
        return this.currentCharacter;
    }
    toJSON() {
        return {
            id: this.id,
            playerName: this.playerName,
            characterName: this.characterName,
            currentCharacter: this.characterName,
            userId: this.userId,
            inventory: [...this.inventory],
            stats: [...this.stats],
            sceneHistory: [...this.sceneHistory],
            currentScene: this.currentScene,
            completed: this.completed,
            hasActiveAdventures: this.hasActiveAdventures,
            openingSessionTopValid: this.openingSessionTopValid,
            activeAdventureDetails: this.activeAdventureDetails,
            timeZoneOffsetMinutes: this.timeZoneOffsetMinutes
        };
    }
}
exports.Player = Player;
//# sourceMappingURL=Player.js.map